import { formatImagenFilename, normalizeImagenDate } from "./filenames.js";

export const editorialTeamPhotoSlotId = "edi_team_pose1" as const;

export const mediaDaySlotDefinitions = [
  {
    id: "cut_f",
    setKind: "cutout",
    subject: "player",
    displayName: "Crossed Arms Front",
    photoKind: "cutout",
    outputType: "cut",
    pose: "f",
    label: "Select",
    rating: 1,
    defaultHotkey: "1",
  },
  {
    id: "dc_pose1",
    setKind: "cutout",
    subject: "player",
    displayName: "DC Pose 1",
    photoKind: "digital_composition",
    outputType: "dc",
    pose: "pose1",
    label: "Second",
    rating: 3,
    defaultHotkey: "Shift+1",
  },
  {
    id: "dc_pose2",
    setKind: "cutout",
    subject: "player",
    displayName: "DC Pose 2",
    photoKind: "digital_composition",
    outputType: "dc",
    pose: "pose2",
    label: "Second",
    rating: 4,
    defaultHotkey: "Shift+2",
  },
  {
    id: "dc_pose3",
    setKind: "cutout",
    subject: "player",
    displayName: "DC Pose 3",
    photoKind: "digital_composition",
    outputType: "dc",
    pose: "pose3",
    label: "Second",
    rating: 5,
    defaultHotkey: "Shift+3",
  },
  {
    id: "cut_pose1",
    setKind: "cutout",
    subject: "player",
    displayName: "Cut Pose 1",
    photoKind: "cutout",
    outputType: "cut",
    pose: "pose1",
    label: "Select",
    rating: 2,
    defaultHotkey: "2",
  },
  {
    id: "cut_pose2",
    setKind: "cutout",
    subject: "player",
    displayName: "Cut Pose 2",
    photoKind: "cutout",
    outputType: "cut",
    pose: "pose2",
    label: "Select",
    rating: 3,
    defaultHotkey: "3",
  },
  {
    id: "cut_pose3",
    setKind: "cutout",
    subject: "player",
    displayName: "Cut Pose 3",
    photoKind: "cutout",
    outputType: "cut",
    pose: "pose3",
    label: "Select",
    rating: 4,
    defaultHotkey: "4",
  },
  {
    id: "cut_pose4",
    setKind: "cutout",
    subject: "player",
    displayName: "Cut Pose 4",
    photoKind: "cutout",
    outputType: "cut",
    pose: "pose4",
    label: "Select",
    rating: 5,
    defaultHotkey: "5",
  },
  {
    id: "cut_pose5",
    setKind: "cutout",
    subject: "player",
    displayName: "Cut Pose 5",
    photoKind: "cutout",
    outputType: "cut",
    pose: "pose5",
    label: "Second",
    rating: 1,
    defaultHotkey: "6",
  },
  {
    id: "cut_pose6",
    setKind: "cutout",
    subject: "player",
    displayName: "Cut Pose 6",
    photoKind: "cutout",
    outputType: "cut",
    pose: "pose6",
    label: "Second",
    rating: 2,
    defaultHotkey: "7",
  },
  {
    id: "cut_key",
    setKind: "cutout",
    subject: "player",
    displayName: "Key",
    photoKind: "cutout",
    outputType: "cut",
    pose: "key",
    label: "Approved",
    rating: 5,
    defaultHotkey: "8",
  },
  {
    id: "edi_pose1",
    setKind: "editorial",
    subject: "player",
    displayName: "Editorial Pose 1",
    photoKind: "editorial_solo",
    outputType: "edi",
    pose: "pose1",
    label: "Approved",
    rating: 1,
    defaultHotkey: "1",
  },
  {
    id: "edi_pose2",
    setKind: "editorial",
    subject: "player",
    displayName: "Editorial Pose 2",
    photoKind: "editorial_solo",
    outputType: "edi",
    pose: "pose2",
    label: "Approved",
    rating: 2,
    defaultHotkey: "2",
  },
  {
    id: "edi_pose3",
    setKind: "editorial",
    subject: "player",
    displayName: "Editorial Pose 3",
    photoKind: "editorial_solo",
    outputType: "edi",
    pose: "pose3",
    label: "Approved",
    rating: 3,
    defaultHotkey: "3",
  },
  {
    id: editorialTeamPhotoSlotId,
    setKind: "editorial",
    subject: "team",
    displayName: "Team Photo",
    photoKind: "editorial_team",
    outputType: "edi",
    pose: "pose1",
    label: "Review",
    rating: 1,
    defaultHotkey: "T",
  },
  {
    id: "edi_team_pose2",
    setKind: "editorial",
    subject: "team",
    displayName: "Team Pose 2",
    photoKind: "editorial_team",
    outputType: "edi",
    pose: "pose2",
    label: "Review",
    rating: 2,
    defaultHotkey: "Shift+2",
  },
  {
    id: "edi_team_pose3",
    setKind: "editorial",
    subject: "team",
    displayName: "Team Pose 3",
    photoKind: "editorial_team",
    outputType: "edi",
    pose: "pose3",
    label: "Review",
    rating: 3,
    defaultHotkey: "Shift+3",
  },
] as const;

export type MediaDaySlotDefinition = (typeof mediaDaySlotDefinitions)[number];
export type MediaDaySlotId = MediaDaySlotDefinition["id"];
export type MediaDaySetKind = MediaDaySlotDefinition["setKind"];
export type MediaDaySubject = MediaDaySlotDefinition["subject"];
export type MediaDayPhotoKind = MediaDaySlotDefinition["photoKind"];

export const isEditorialPlayerTeamPhotoSlot = ({
  slotId,
  setKind,
  subject,
}: {
  slotId: string;
  setKind: MediaDaySetKind | null;
  subject: MediaDaySubject | null;
}) => slotId === editorialTeamPhotoSlotId && setKind === "editorial" && subject === "player";

export const mediaDaySlotById = new Map(
  mediaDaySlotDefinitions.map((slot) => [slot.id, slot] as const),
);

const slotByBridgeMarking = new Map<string, MediaDaySlotId>(
  mediaDaySlotDefinitions.map(
    (slot) => [`${slot.label.toLowerCase()}|${slot.rating}`, slot.id] as const,
  ),
);

export const isMediaDaySlotId = (value: string): value is MediaDaySlotId =>
  mediaDaySlotById.has(value as MediaDaySlotId);

export const mediaDaySlotForBridgeMarking = (label: string | null, rating: number) =>
  label ? (slotByBridgeMarking.get(`${label.trim().toLowerCase()}|${rating}`) ?? null) : null;

export const mediaDaySlotsFor = (setKind: MediaDaySetKind, subject: MediaDaySubject) =>
  mediaDaySlotDefinitions.filter((slot) => slot.setKind === setKind && slot.subject === subject);

export const buildMediaDayCutSlotLabels = (categoryNames: (string | null | undefined)[]) => {
  const cutSlots = mediaDaySlotsFor("cutout", "player").filter((slot) =>
    slot.id.startsWith("cut_pose"),
  );
  return Object.fromEntries(
    cutSlots.flatMap((slot, index) => {
      const label = categoryNames[index]?.trim();
      return label ? [[slot.id, label] as const] : [];
    }),
  ) as Partial<Record<MediaDaySlotId, string>>;
};

export const buildMediaDayOutputStem = ({
  gameToken,
  teamToken,
  playerToken,
  slotId,
}: {
  gameToken: string;
  teamToken: string;
  playerToken: string | null;
  slotId: MediaDaySlotId;
}) => {
  const slot = mediaDaySlotById.get(slotId);
  if (!slot) return null;
  if (slot.subject === "team") return `${gameToken}_${teamToken}_edi_team_${slot.pose}`;
  if (!playerToken) return null;
  return `${gameToken}_${teamToken}_${playerToken}_${slot.outputType}_${slot.pose}`;
};

export const buildMediaDayImagenEditorialOutputStem = ({
  date,
  gameToken,
  teamToken,
  playerToken,
  slotId,
}: {
  date: string;
  gameToken: string;
  teamToken: string;
  playerToken: string | null;
  slotId: MediaDaySlotId;
}) => {
  const slot = mediaDaySlotById.get(slotId);
  const normalizedDate = normalizeImagenDate(date);
  if (!slot || slot.setKind !== "editorial" || !normalizedDate) return null;
  if (slot.subject === "player" && !playerToken) return null;

  return formatImagenFilename({
    date: normalizedDate,
    game: gameToken,
    team: teamToken,
    player: playerToken,
    kind: "EDI",
    pose: slot.pose,
    teamAsset: slot.subject === "team",
  });
};
